export default __webpack_public_path__ + "static/media/CouponManagement.b5a318e7.png";